var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventObj)?_c('transactions',{attrs:{"event":_vm.eventObj}}):_c('spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }